const TimeAttendance = {
  // A
  absent: 'غائب',
  actual_overtime: 'ساعات العمل الاضافية الفعلية',
  am_or_pm: 'صباحاً أو مساءً',
  article_link: 'رابط المقالة',
  absent_tip: 'غياب',
  approve_and_submit: 'موافقه وتأكيد',
  approved_overtime: 'عمل إضافي معتمد',
  attendance_status: 'حالة الحضور',
  actual_delay: 'التأخير الفعلي',
  approved_on: 'التأكيد في',
  attendance_change: 'تغيير الحضور',
  attendance_sheet_submitted_successfully: '{{month}} {{year}} تم قبول ملف الحضور والغياب بنجاح',
  attendance_sheet_dismissed_successfully: '{{month}} {{year}} تم استبعاد ملف الحضور والغياب بنجاح',
  attendance_sheet_reopened_successfully:
    '{{month}} {{year}} تم إلغاء تأكيد ملف الحضور والغياب بنجاح',
  are_you_sure_you_want_to_dismiss_the_attendance:
    'هل أنت متأكد أنك تريد رفض الحضور لـ {{month}} {{year}}؟',
  actual_shortage: 'النقص الفعلي',
  actual_early_departure: 'الخروج المبكر الفعلي',
  actual_late_arrival: 'الدخول المتأخر الفعلي',
  any_attendance_incident_that_would_normally:
    'سيتم الغاء اي خصمية حضور او انصراف كخصميات الغياب أو الوصول المتأخر أو المغادرة المبكرة ولن تسري الخصومات على جدول الرواتب هذا.',
  approved_requests_that_were_raised:
    'سيتم إلغاء الطلبات المعتمدة التي تم رفعها لتجنب خصم محتمل مثل الوصول المتأخر والمغادرة المبكرة وطلبات الأعذار ليوم كامل أو طلبات  التصحيح نظرًا لعدم سريان أي خصم من المقام الأول.',
  additions_from_approved_overtime:
    '.لن يتم دفع الإضافات من طلبات العمل الإضافي الموافق عليها في كشوف المرتبات هذه ، وسيتم إخطار الموظفين المتأثرين.',
  are_you_sure_approve_pending_request:
    'مازال لديك  {{pending_requests}} طلبات معلقة, هل أنت متأكد أنك تريد الإرسال ؟ ',
  and_it_ends_once_the_payroll_is_confirmed:
    'وتنتهي بمجرد تأكيد كشوف المرتبات أو عند التقديم الناجح.',
  automatically_add_by_shift: 'تمت الإضافة تلقائياً من فترة الدوام',
  at: 'الساعة',
  At: 'في',
  approve_and_submit_anyway: 'موافقة، وارسال على اي حال',
  assign_now: 'أضف الأن',
  abnormal: 'غير طبيعي',
  approved_ot: 'عمل إضافي معتمد',
  allowed: 'المسموح',
  actual: 'الفعلي',
  assigned_locations: 'المواقع المعينة',
  allow_to_clock_offsite: 'السماح بتسجيل الحضور والخروج من أي موقع (دون التقيّد بالموقع المحدد)',
  allowed_to_clock_offsite: 'يمكن تسجيل الحضور والخروج من أي موقع (دون التقيّد بالموقع المحدد)',
  automatically_added: 'تم أضافتها تلقائيا',
  approve_sheet: 'إعتماد الكشف',
  Attendance_sheet_might_not_accurate: 'كشف الحضور والانصراف قد لايكون دقيق',
  attendance_day: 'يوم الدوام',
  attendance_duration: 'ايام الدوام',
  add_attatchment: 'إضافة مرفق',
  attendance_record: 'سجل الحضور',
  add_day: 'أضافة يوم',
  a_shift_need_to_assigned: 'يجب تعيين دوام من أجل حساب وتسجيل ساعات العمل',
  attendance_sheets: 'كشوفات الحضور',
  asked_for_cancellation_by: 'طلب الإلغاء مرسل من',
  all_schedule: 'عرض الكل',
  // B
  bulk_days: 'ايام متعددة',
  business_unit: 'وحده العمل',
  bio_metric_devices: 'اجهزة البصمة',
  by_shift: 'من خلال الدوام',
  bulk_overtime: 'Bulk overtime:ar',
  back_step: 'تراجع',
  // C
  check_in: 'تسجيل الدخول',
  check_out: 'تسجيل الخروج',
  comment_placeholder: 'اكتب تعليقك هنا',
  clocked_in: 'سجلت في',
  clocked_out: 'تم تسجيله',
  clock_out_time: 'وقت تسجيل الانصراف',
  clear_all_deductions: 'إزالة جميع الخصومات',
  columns: 'الأعمدة',
  days_off: 'أيام الراحة',
  Delay: 'التأخير',
  correction_requests: 'طلبات التصحيح',
  cancellation: 'الغاء',
  choose_another_person_decide: 'اختر شخصًا آخر لاتخاذ القرار نيابة عنك',
  choose_shift_replacement: 'اختر الفترة البديلة',
  correction_date_and_type: 'تاريخ التصحيح',
  correction: 'تصحيح',
  clock_in_time: 'وقت تسجيل الحضور',
  cancel_submission: 'إلغاء الاعتماد',
  cancel_attendance_sheet_submission: 'التراجع عن اعتماد كشف الحضور',
  cant_select_time_before_shift: 'لايمكن اختيار وقت قبل وقت بدء الدوام لطلب إستئذان منتصف اليوم',
  cant_select_time_after_shift: 'لايمكن اختيار وقت بعد وقت انتهاء الدوام لطلب إستئذان منتصف اليوم',
  cant_select_time_before_after_shift:
    'لايمكن اختيار وقت قبل وقت بدء الدوام او وقت بعد وقت انتهاء الدوام لطلب إستئذان منتصف اليوم',
  cant_select_time_before_from_time: 'لايمكن اختيار وقت قبل او يساوي وقت بدء الإستئذان',
  // D
  day: 'يوم',
  Date: 'التاريخ (ميلادي)',
  delay_tip: 'الوقت الذي سجل على الموظف بسبب تأخره في الحضور عن وقت بداية الدوام المطلوب منه.',
  daily_view: 'العرض اليومي',
  Department: 'قسم',
  dismiss_attendance: 'استبعاد الحضور والانصراف',
  dismissed: 'مستبعد',
  document_ID: 'معرف المستند',
  days_with_overtime: 'الأيام مع العمل الإضافي',
  hours_with_overtime: 'الساعات مع العمل الإضافي',
  dismissing_attendance_means_that_employees:
    'رفض ملف الحضور والإنصراف يعني أن رواتب الموظفين لن تتأثر بسجلات الحضور الخاصة بهم ، وسيتم دفع أجور الموظفين من غير اضافات او خصومات قادمة من حضورهم وأنصرافهم.',
  do_you_really_want_to_delete_it: 'هل تريد فعلاً أن تحذف؟',
  difference: 'الفرق',
  device_info: 'معلومات الجهاز',
  dismiss_sheet: 'الإرسال دون احتساب الإضافات والخصميات',
  days: 'أيام',
  delay_duration: 'مدة التأخير',
  delegate_decision: 'قرار المندوب',
  decision_will_passed: 'سيتم تمرير القرار إلى الموافق التالي',
  deductable: 'خصمية',
  different_durations: 'مدة مختلفة لكل يوم',
  duration_period: 'المدة المجدولة',
  delay_deduction: 'خصمية التأخير',
  // E
  employee_attendance_details: 'تفاصيل حضور وانصراف الموظف',
  employment_type: 'نوع الوظيفة',
  excused_time: 'تأخير مسموح',
  extra_hours: 'الوقت الإضافي',
  excused_delay_tip: 'الوقت الذي تم السماح للموظف بالتأخير فيه',
  excused_shortage_tip: 'الوقت الذي تم السماح للموظف بالخروج المبكر فيه',
  extra_time_tip:
    ' فترة زمنية إضافية أمضاها الموظف في العمل زيادة عن ساعات العمل المطلوبة منه  أو خارجها؛ وذلك إما بقدومه مبكرًا قبل بداية  الدوام، أو بخروجه متأخرا بعد نهاية الدوام.',
  extra_time: 'ساعات اضافية',
  excuse_time_field_valedation_1: 'دقائق الإستئذان يجب ان تكون أكتر من ٥ دقائق ',
  excuse_time_field_valedation_2: 'يجب ان لا يزيد وقت الإستئذان عن 6 ساعات',
  ex_personal: 'شخصي',
  ex_business: 'العمل',
  excuse_time: 'مدة الإستئذان',
  expected_hours: 'عدد الساعات',
  excused_shortage: 'خروج مبكر بإذن',
  excused_delay: 'تأخير بإذن',
  early_departure: 'المغادرة مبكراً',
  excused_late_arrival: 'تأخير بإذن',
  excused_early_departure: 'خروج مبكر بإذن',
  edit_information: 'تعديل المعلومات',
  edit_time: 'تعديل المعلومات',
  edit_logs_hint_message:
    'اذا قمت بتعديل وقت الدخول/وقت الخروج, فأن البصمة القادمة من طرق رفع سجلات الحضور لن تقوم بااستبدالها.',
  excuse_date_cant_be_before_days: 'تاريخ طلب الإستئذان لايمكن ان يكون قبل 60 يوم في الماضي',
  early_out: 'انصراف مبكّر',
  early_in: 'حضور مبكر',
  employee_attendance: 'تفاصيل الموظف',
  early_outs: 'خروج مبكر',
  exempted: 'معفى',
  employees_review_period: 'الموظفين في فترة المراجعة',
  excuse_requests: 'طلبات الأستئذان',
  estimated_delay_duration: 'مدة التأخير المقدرة: (<b>{{minutes}}</b>)',
  estimated_shortage_duration: 'مدة النقص المقدرة: (<b>{{minutes}}</b>)',
  estimated_clock_in_time: 'وقت الحضور المتوقع',
  estimated_clock_out_time: 'وقت الانصراف المتوقع',
  enter_time_manually: 'أدخل الوقت يدويًا',
  early_out_excuse: 'إستئذان انصراف مبكر',
  entry_method: 'توزيع الساعات',
  edited: 'تم تعديله',
  enter_your_reason: 'ادخل السبب',
  excuse_date_and_type: 'يوم الإستئذان ونوعه',
  excuse_duration: 'مدة الإستئذان',
  exempted_from_attendance_deductions: 'معفي من خصميات الحضور والانصراف',
  exclude_exempted_employees: 'اخفاء المعفيين من الحضور والإنصراف',
  employee_in_this_sheet: 'الموظفين في هذا الكشف',
  estimated_excused_time: 'الوقت المقدر للإستئذان',
  estimated_excused_duration: 'المدة المقدرة للإستئذان',
  // F
  first_shift_in_time: 'وقت بداية الفترة الأولى من الدوام',
  first_shift_out_time: 'وقت نهاية الفترة الأولى من الدوام',
  full_day_excuse: 'إستئذان يوم كامل',
  full_day: 'يوم كامل',
  from_you: 'انت',
  from_other_approvals: 'من الأخرين',
  first_in: 'أول حضور',
  facility: 'المنشأة',
  // G
  grade: 'الدرجة',
  go_back: 'رجوع',
  go_back_recommended: 'رجوع (يفضل)',
  go_to_settings: 'الذهاب إلى الإعدادت',
  go_to_template_settings: 'الذهاب لإعدادات دوام العمل',
  got_approved_overtime: 'لديهم عمل إضافي معتمد',
  got_deductables: 'لديهم خصومات',
  got_retroactives: 'لديهم أثر رجعي',
  got_pending_requests: 'لديهم طلبات معلقة',
  got_unscheduled_days: 'لديهم أيام غير مجدولة',
  got_incomplete_records: 'لديهم سجلات غير مكتملة',
  got_incomplete_schedule: 'دون دوام مجدول',
  got_incomplete_schedule_summary: 'لديهم جدول دوام غير مكتمل',
  got_deductions: 'لديهم خصميات',
  got_retroactive_transactions: 'لديهم معاملات بأثر رجعي',
  // H
  hide_comments: 'اخفاء التعليقات',
  holiday: 'عطلة',
  hours: 'ساعة / ساعات',
  how_does_it_affect_payroll: 'كيف تؤثر على كشوف المرتبات ؟',
  hide_shift_rules: 'إخفاء آلية تسجيل الحضور والانصراف',
  hr_1: 'ساعة',
  hr_2: 'ساعتين',
  hr: 'ساعات',
  hide_map: 'إخفاء الخريطة',
  high_to_low: 'من الأعلى الى الأقل',
  highlights: 'معلومات عامة',
  highest_positive_difference: 'الفرق الايجابي الاعلى قيمة',
  highest_negative_difference: 'الفرق السلبي الاعلى قيمة',
  // I
  in_time: 'وقت الدخول',
  in: 'الحضور',
  include_exempted_employees: 'إظهار المعفيين من الحضور والإنصراف',
  incident_date: 'تاريخ الحالة',
  if_an_employee_was_on_leave_period:
    'إذا كان الموظف في فترة إجازة لم تتم الموافقة عليها ، فسيتم اعتباره غائبًا.',
  if_excuse_requests_werent_approved:
    'إذا لم تتم الموافقة على طلبات العذر ، فقد يتم خصم ساعات التأخير او الخروج المبكر بناء على السجلات الفعلية.',
  if_overtime_requests_werent_approved:
    'إذا لم تتم الموافقة على طلبات العمل الإضافي ، فلن يتم دفع ساعات العمل الإضافي.',
  it_seems_no_overview_requests: 'يبدو أنه لا توجد معلومات',
  it_seems_no_retroactives_requests: 'يبدو أنه لا يوجد اي أثر رجعي في سجل الحضور والانصراف هذا',
  it_seems_no_pending_requests: 'يبدو أنه لا توجد طلبات معلقة في سجل الحضور والانصراف هذا',
  if_an_employee_was_on_a_leave:
    'إذا كان الموظف في فترة إجازة لم تتم الموافقة عليها ، فسيتم دفع أجره بشكل طبيعي ولن يتأثر رصيد إجازته.',
  if_missing_punch_requests_werent_approved:
    'في حال عدم الموافقة على طلب تصحيح فقدان البصمة، الموظف سيظل في حالة سجل غير مكتمل.',
  incomplete_records: 'سجل غير مكتمل',
  incomplete_record: 'سجل غير مكتمل',
  incomplete_schedule: 'دون دوام مجدول',
  incomplete_records_days: 'أيام بسجلات غير مكتملة',
  // J
  job_Title: 'المسمى الوظيفي',
  joining_date: 'تاريخ الانضمام (ميلادي)',
  // K
  // L
  leave: 'إجازة',
  leaving_early: 'المغادرة مبكراً',
  late_arrival: 'الوصول المتأخر',
  last_edited_on: 'تم التعديل في',
  location: 'الموقع',
  late_in: 'حضور متأخر',
  less_details: 'تفاصيل اقل',
  leave_and_overtime_requests: '.سيتم ترحيل طلبات الإجازة والعمل الإضافي وتظل معلقة',
  late_arrival_excuse: 'عذر الوصول المتأخر',
  late_out: 'خروج متأخر',
  last_out: 'آخر انصراف',
  late_ins: 'حضور متأخر',
  low_to_high: 'من الأٌقل الى الأعلى',
  late_in_excuse: 'إستئذان حضور متاخر',
  last_action_by: 'آخر إجراء بواسطة',
  // M
  missed_punch: 'البصمة المفقودة',
  missing_punch: 'السجل الغير مكتمل',
  missing: 'نسيان بصمة',
  missing_punches_tip: 'نسيان بصمه',
  monthly_view: 'العرض الشهري',
  missing_punch_date: 'تاريخ السجل الغير مكتمل',
  missing_punch_date_cant_be_before_days: 'تاريخ طلب التصحيح لايمكن ان يكون قبل 60 يوم في الماضي',
  multiple_shifts_were_scheduled: 'تم جدولة دوام عمل او عدة دوامات ولكن لم يتم نشرها بعد',
  missed_shift: 'غياب جزئي',
  monthly: 'شهري',
  min_1: 'دقيقه',
  min_2: 'دقيقتين',
  min: 'دقائق',
  m: 'م',
  missed_shifts_duration: 'مدة الغياب الجزئي',
  missed_shifts: 'غياب جزئي',
  missed_shift_deduction: 'خصمية الغياب الجزئي',
  manual: 'يدوي',
  min_delay: 'تاخير',
  multiple_days: 'أيام محددة',
  min_shortage: 'انصراف مبكّر',
  monthly_payroll: 'مراجعة شهرية',
  missing_punch_date_and_type: 'نوع و وقت البصمة المفقودة',
  month_attendance: 'حضور شهر {{month}}',
  middle_of_day_excuse: 'منتصف اليوم',
  // N
  not_joined_yet: 'لم يلتحق بالشركة بعد',
  nationality: 'الجنسية',
  not_taking_action_on_the_pending_requests:
    'عدم اتخاذ إجراء بشأن الطلبات المعلقة سيؤثر على جدول رواتب موظفيك.',
  no_employees_found: 'لم يتم العثور على موظفين',
  no_attendance_sheets_available: 'لا توجد ملفات حضور وإنصراف لهذا الشهر ',
  no_record: 'لا يوجد سجل',
  no_shift_was_scheduled: 'لا يوجد دوام مجدول',
  need_attention: 'حالات تحتاج الى انتباه',
  not_required: 'حضور غير مطلوب',
  no_of_days: 'عدد الأيام',
  no_delay_was_recorded_for_this_shift:
    'لم يتم تسجيل أي تأخير لهذا الدوام. ليست هناك حاجة لطلب إستئذان.',
  no_shortage_was_recorded_for_this_shift:
    'لم يتم تسجيل نقص لهذا الدوام. ليست هناك حاجة لطلب إستئذان.',
  no_attendance_required_on_this_day:
    ' لا حاجة لتقديم طلب إستئذان لأن الحضور غير مطلوب لهذا اليوم، وقد يكون هذا اليوم هو: <ul> <li> يوم راحة </li> <li> يوم عطلة </li> <li> يوم إجازة موافق عليها </li> </ul>',
  no_shift_assigned: 'لا يوجد دوامات مخصصة',
  no_attendance_required: 'حضور غير مطلوب',
  // O
  out_time: 'وقت الخروج',
  out: 'الانصراف',
  out_of_clocking_windows: 'خارج النوافذ الزمنية',
  Overtime: 'ساعات العمل الاضافي',
  overtime_hours: 'ساعات الأوفرتايم',
  overtime_ta_tip:
    'ساعات عمل إضافية تم تكليف الموظف بها أو الموافقة علي طلب قيمة هذه الساعات الإضافية, وتؤثر مباشرة في مسير الرواتب',
  overtime_type: 'نوع الوقت الإضافي',
  overtime_date: 'تاريخ الوقت الإضافي',
  overtime_date_cant_be_before_days: 'تاريخ طلب العمل الإضافي لايمكن ان يكون قبل 60 يوم في الماضي',
  overtimes: 'ساعات إضافية',
  once_you_approve_the_attendance_report_it_will_be_sent:
    'بمجرد الموافقة على تقرير الحضور ، سيتم إرساله لمعالجة كشوف المرتبات. أي انعكاسات حضور أخرى أو طلبات تمت الموافقة عليها بعد هذه النقطة لن تسري إلا في الشهر المقبل. <b>هل أنت جاهز للإرسال؟</b>',
  once_you_submit_the_attendance: '.لايمكن اعادة فتح سجل الحضور والانصراف بعد رفعه',
  overtime_one_total_distributed_equally: 'مدة مقسمة بالتساوي',
  off_day: 'يوم عطله',
  // P
  pending_on: 'معلق من قبل',
  presen: 'حاضر',
  present: 'حاضر',
  public_holiday: 'عطلة رسمية',
  performed_by: 'بواسطة',
  payroll_reflection: 'التأثير على مسيّر الرواتب',
  payroll_cycle: 'فترة الرواتب',
  punches: 'البصمات',
  punctuality_deductables: 'خصميات الانضباط',
  proposed_correction_time: 'وقت التصحيح المقترح',
  proposed_correction: 'التصحيح المقترح',
  processing: 'تحت المعالجه',
  proceed_to_cancel_submission: 'تود الاستمرار في إلغاء اعتماد هذا الكشف؟',
  // Q
  // R
  reason_type: 'سبب الإستئذان',
  retroactives: 'الاثر الرجعي',
  request: 'طلب',
  requested: 'القيمة المطلوبة',
  requested_days: 'الأيام المطلوبة',
  review_and_submission: 'المراجعة والاعتماد',
  requested_on: 'يوم الطلب',
  requested_excuse_period: 'فترة العذر المطلوبة',
  records_need_to_be_recalculated: '{{count}} سجل بحاجة الى اعادة احتساب',
  recalculate_now: 'إعادة الحساب الآن',
  requested_period: 'الفترة المطلوبة',
  requested_overtime_more_than_actual_overtime:
    'ساعات العمل الاضافية المطلوبة اكثر من ساعات العمل الاضافية الفعلية',
  requests_that_were_raised_to_recover:
    'سيتم إلغاء الطلبات التي تم تقديمها للتعافي من خصم محتمل مثل طلبات الوصول المتأخر والمغادرة المبكرة وطلبات الأعذار ليوم كامل أو طلبات التصحيح.',
  retroactives_that_appear:
    '.لن يؤثر الاثر الرجعي الذي يظهر في الدورة الحالية على كشوف مرتبات الموظفين.',
  retroactive_pay_is_compensation:
    'الأثر الرجعي، هي قيمة تضاف/تخصم من الموظف كتعويض من فترة سابقة، في {{app_name}} يحدث ذلك عند الموافقة على طلب حيث ان التغيير الناتج من الموافقة على الطلب يقع في فترة مسير رواتب سابق و سجل الحضور والانصراف الخاص بهذا المسير تم الموافقة عليه، فبالتالي سوف يتم انشاء اثر رجعي في الشهر التالي بشكل اتوماتيكي',
  review_now: 'راجع الان',
  reason_of_reject: 'سبب الرفض',
  record: 'السجل',
  reflection: 'التأثير على الراتب',
  roaster_rotating: 'دوام متغيّر',
  reporting_methods: 'آلية تسجيل الحضور',
  request_approved_at: 'تمت الموافقة على الطلب في',
  review_approval: 'المراجعة والتأكيد',
  recorded: 'المسجل',
  reporting_methods_settings: 'اعدادات طرق رفع السجلات',
  remind_approvers: 'تذكير المسؤولين',
  requested_duration: 'المدة المطلوبة',
  recorded_clock_in: 'وقت الحضور المسجل',
  recorded_clock_out: 'وقت الانصراف المسجل',
  recorded_clock_in_time: 'وقت الحضور المسجل',
  recorded_clock_out_time: 'وقت الانصراف المسجل',
  requester_associated_correction_with_Late:
    'Requester has associated this correction with a Late In excuse request. The excuse request will be issued automatically upon approval of this correction:ar',
  requested_by: 'أنشئ الطلب من',
  record_changes: 'التغيّر في السجل',
  remove_day_off: 'إزالة يوم راحة',
  remove_all_deductibles: 'إزالة جميع الخصميات',
  remove_all_deductables_modal_message:
    'إزالة الخصميات ستكون بزيادة المدة المسموح بها لتعادل المدة المسجلة للحضور المتأخر او الانصراف المبكر',
  // S
  shortage: 'التقصير',
  second_shift_in_time: 'وقت بداية الفترة الثانية من الدوام',
  second_shift_out_time: 'وقت نهاية الفترة الثانية من الدوام',
  single_day: 'يوم واحد',
  shortage_tip:
    'الوقت الذي سجل على الموظف بسبب عدم اكماله ساعات العمل الى وقت انتهاء الدوام المطلوب منه',
  shift_name_tip: 'اسم الدوام',
  sync_now: 'Sync now',
  shift_info: 'معلومات الدوام',
  split_first_shift: 'الفترة الأولى: {{first}} - {{last}}',
  split_second_shift: 'الفترة الثانية: {{first}} - {{last}}',
  split_first_in_out: 'الفترة الأولى: {{time}}',
  split_second_in_out: 'الفترة الثانية: {{time}}',
  split_time: 'الوقت الفاصل',
  select_time: 'اختر الوقت',
  shift_one: 'الفترة الأولى',
  shift_two: 'فترة ثانية',
  shift_name: 'اسم الدوام',
  shift_type: 'نوع الدوام',
  punch_in: 'punch_in AR',
  punch_out: 'punch_out AR',
  shift_location: 'موقع الدوام',
  shift_start_time: 'وقت بداية الدوام',
  shift_end_time: 'وقت نهاية الدوام',
  second_shift_start_time: 'وقت بدء الدوام الثاني',
  second_shift_end_time: 'وقت انتهاء الدوام الثاني',
  second_shift_in: 'بداية الفترة الثانية',
  second_shift_out: 'نهاية الفترة الثانية',
  show_comments: 'عرض التعليقات',
  show_records_in_days: 'عرض السجلات بالأيام',
  show_records_in_hours: 'عرض السجلات بالساعات',
  search_by_employee_id_or_name: 'البحث عن طريق معرف الموظف أو الاسم',
  search_by_employee_id_name_objective_name: 'البحث عن طريق معرف الموظف أو اسمه او اسم الهدف',
  second_shift_clock_in: 'وقت دخول الدوام الثاني',
  second_shift_clock_out: 'وقت خروج الدوام الثاني',
  submitted: 'قدمت',
  sort_a_to_z: 'ترتيب تصاعدي من أ ← الى ي',
  sort_z_to_a: 'ترتيب تنازلي من ي ← الى أ',
  submission_window_is_the_time_where:
    'نافذة التقديم هي الوقت الذي ستتمكن فيه من إرسال كشف / تقرير الحضور إلى مسؤول كشوف المرتبات لمعالجته ، و <b> يبدأ بعد تاريخ إنهاء كشوف المرتبات </ b> الذي تم تعيينه في كشوف المرتبات التكوين ، وهو في حالتك هو:',
  source: 'مصدر',
  summary_sheet: 'ورقة الملخص',
  shift_ended_without_any_clock: 'انتهى الدوام دون تسجيل للحضور والانصراف',
  show_shift_rules: 'إظهار آلية تسجيل الحضور والانصراف',
  scheduled_hrs: 'ساعات مجدولة',
  show_map: 'عرض الخريطه',
  sort_by_extra_time: 'ترتيب حسب الوقت الإضافي',
  sort_by_shortage: 'ترتيب حسب الخروج المبكر',
  shift_schedule: 'جدول الدوامات',
  show_on_scheduler: 'عرض على جدول الدوامات',
  sheet: 'الكشف',
  some_employees_have_unscheduled_days:
    'بعض الموظفين لديهم أيام غير مجدولة أو سجلات غير مكتملة مما يؤثر على دقة كشوفات حضورهم. ننصح بمعالجة الحالات التي تم إبرازها لتجنب تأثيرات غير مرغوب فيها على مسيّر الرواتب',
  shift_timing: 'وقت الدوام',
  Shortage: 'التقصير',
  scheduled_duration: 'المدة المجدولة',
  see_what_would_change_on_record: 'تأثير قبول الطلب على سجل الحضور',
  set_as_day_off: 'يوم راحة',
  skip_decision: 'Skip Decision:ar',
  shortage_duration: 'مدة التقصير',
  select_from_existing_punch: 'تحديد من البصمات الموجوده',
  select_punch: 'تحديد بصمه',
  shift_settings: 'إعدادات الدوام ',
  show_geo_location: 'عرض الموقع الجغرافي',
  scheduled_att: 'المجدول',
  shift_time: 'وقت الدوام',
  shift_duration: 'المدة',
  shortage_deduction: 'خصمية التقصير',
  schedule: 'جدول الدوام',
  my_schedule: 'جدول الدوام',
  // T
  attendance_leaves: 'الحضور & الإجازات',
  time_main_navigation: 'الحضور والإنصراف',
  time: 'الوقت',
  timesheet_type: 'نوع ملف الحضور والانصراف',
  total_number_of_approved_business: 'إجمالي طلبات الإستئذان (للعمل)',
  total_number_of_approved_personal: 'إجمالي طلبات العمل (شخصي)',
  total_worked_hours: 'إجمالي ساعات العمل',
  total_worked_days: 'إجمالي ايام العمل',
  type_your_comment_here: 'اكتب تعليقك هنا',
  this_happen_when_an_attendance:
    'يحدث هذا عندما يكون هناك تغير في سجلات الحضور والانصراف - كتغير ناجم عن قبول طلب استأذان - وبالتالي سجل حضور وانصراف الموظف الناجم عن التغير الجديد سيتم اعادة احتسابه بشكل تلقائي من قبل النظام، وهذا قد يستغرق بعض من الدقائق، مع ذلك يمكن للمدير تفعيل اعادة الاحتساب بشكل لحظي ويدوي لكل 50 سجل.',
  the_employee: 'موظف',
  the_requested_overtime_is_more_than:
    'الوقت الإضافي المطلوب هو أكثر من العمل الإضافي الفعلي المسجل.',
  tracking: 'المتابعة',
  times_late_in: 'مرات الحضور المتأخر',
  times_early_out: 'مرات الانصراف المبكر',
  total_shortage: 'إجمالي التقصير',
  total_delay: 'إجمالي التأخير',
  the_full_recorded_duration: 'إجمالي المدة المسجلة (<b>{{minutes}} دقائق</b>)',
  total_extra_worked_hrs: 'إجمالي العمل الإضافي',
  this_will_withdraw_all_submitted_attendance_calculations:
    'سيلغى إعتماد كشف الحضور وتأثيره على مسيّر الرواتب. وستتمكن من مراجعة الكشف واعتماده مرة أخرى. ',
  total_working_hours: 'اجمالي ساعات العمل',
  total_working_hours_inside_the_shifts: 'إجمالي ساعات العمل داخل الدوام',
  // U
  unavailable: 'غير متاح',
  undo: 'تراجع',
  unregistered: 'غير مسجل',
  upload_bulk_overtime: 'رفع ساعات العمل الإضافي',
  unscheduled_days: 'أيام غير مجدولة',
  unscheduled_unpublished_days: 'الأيام غير المجدولة / غير المنشورة',
  // V
  view_employee_attendance_details_page: 'عرض صفحة تفاصيل الحضور والغياب للموظف',
  valid_range: 'المجال المسموح به',
  view_on_scheduler: 'عرض على جدول الدوامات',
  view_in_scheduler: 'الرؤية في جدولة الدوامات',
  via_request: 'من خلال طلب',
  // W
  what_happens_to_pending_requests: 'ماذا يحدث للطلبات المعلقة؟',
  what_happens_to_approved_requests: 'ماذا يحدث للطلبات المعتمدة؟',
  What_happens_to_retroactives_from_past_months: 'ماذا يحدث للأثر الرجعي القادم من الشهر الماضي؟',
  what_is_a_retroactive: 'ما هو الأثر الرجعي؟',
  what_is_submission_window: 'ما هي نافذة التقديم',
  worked: 'مدة العمل',
  worked_hrs: 'ساعات العمل',
  worked_duration: 'مدة العمل',
  worked_days: 'أيام عمل',
  working_hours_inside_the_shift: 'ساعات العمل داخل الدوام',
  working_hrs_inside_the_shift: 'ساعات العمل داخل الدوام',

  // X
  // Y
  yes_approve_and_submit: 'نعم، تأكيد الموافقة',
  yes_dismiss_attendance: 'نعم ، رفض الحضور',
  you_are_about_to_approve_and_submit_the_attendance:
    'أنت على وشك الموافقة على تقرير الحضور وإرساله لـ {{month}} {{year}}',
  you_select_punch_already_selected:
    'إخترتَ بصمة سبق وسُجلّت كبصمة إنصراف. في هذه الحالة تحتاج لإقتراح بديل لها.',
  // Z
}

export default TimeAttendance
